import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { OrganizationAffiliation } from "fhir/r5";

interface AffiliationDetailsModalProps {
  open: boolean;
  onClose: () => void;
  affiliation: OrganizationAffiliation;
}

export function AffiliationDetailsModal({
  open,
  onClose,
  affiliation,
}: AffiliationDetailsModalProps) {
  const planName = affiliation.extension?.find(
    (ext) =>
      ext.url ===
      "https://fluxmed.com.br/fhir/StructureDefinition/insurance-plan-affiliation"
  )?.valueReference?.display;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {affiliation.participatingOrganization?.display} - {planName}
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={3} mt={2}>
          {/* Informações do Plano */}
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" fontWeight="600" gutterBottom>
              Informações Gerais
            </Typography>
            <Stack spacing={1}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Organização Principal
                </Typography>
                <Typography>{affiliation.organization?.display}</Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Identificador do Plano
                </Typography>
                <Typography>
                  {affiliation.extension
                    ?.find(
                      (ext) =>
                        ext.url ===
                        "https://fluxmed.com.br/fhir/StructureDefinition/insurance-plan-affiliation"
                    )
                    ?.valueReference?.reference?.replace(
                      "InsurancePlan/",
                      ""
                    ) || "Não especificado"}
                </Typography>
              </Box>
            </Stack>
          </Paper>

          {/* Procedimentos e Valores */}
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" fontWeight="600" gutterBottom>
              Procedimentos e Valores
            </Typography>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Procedimento</TableCell>
                    <TableCell align="right">Valor (R$)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {affiliation.specialty?.map((specialty, index) => {
                    const coding = specialty.coding?.[0];
                    const value = specialty.extension?.find(
                      (ext) =>
                        ext.url ===
                        "https://fluxmed.com.br/fhir/StructureDefinition/service-value"
                    )?.valueMoney?.value;

                    return (
                      <TableRow key={index}>
                        <TableCell>{coding?.code}</TableCell>
                        <TableCell>{coding?.display}</TableCell>
                        <TableCell align="right">
                          {value?.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

          {/* Metadados */}
          <Box>
            <Typography variant="caption" color="text.secondary">
              Última atualização:{" "}
              {new Date(affiliation.meta?.lastUpdated || "").toLocaleString(
                "pt-BR"
              )}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
